/**
* @summary - Component that Provides Work Group Creation Page
* @author Yuvasri S
* @since 2024-05-28
*/
import React from 'react'
import CreateUserLocation from '../../components/userlocationcomponents/CreateUserLocation'

function UserLocationRegister({renderPageContent}) {
    return (
        <>
                        <CreateUserLocation renderPageContent={renderPageContent}/>
                       
                       
        </>
    )
}

export default UserLocationRegister;